module.exports = __webpack_public_path__ + "static/media/capichi_logo.30253858.jpg";